import { render, staticRenderFns } from "./ExpertProfileView.vue?vue&type=template&id=f7db884c&scoped=true"
import script from "./ExpertProfileView.vue?vue&type=script&lang=js"
export * from "./ExpertProfileView.vue?vue&type=script&lang=js"
import style0 from "./ExpertProfileView.vue?vue&type=style&index=0&id=f7db884c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7db884c",
  null
  
)

export default component.exports